// File generated from our OpenAPI spec by Stainless. See CONTRIBUTING.md for details.
import { APIResource } from "../../core/resource.mjs";
import { ArrayPage } from "../../core/pagination.mjs";
import { path } from "../../internal/utils/path.mjs";
export class Folders extends APIResource {
    /**
     * Get the folders associated with an agent.
     */
    list(agentID, query = {}, options) {
        return this._client.getAPIList(path `/v1/agents/${agentID}/folders`, (ArrayPage), {
            query,
            ...options,
        });
    }
    /**
     * Attach a folder to an agent.
     */
    attach(folderID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/folders/attach/${folderID}`, options);
    }
    /**
     * Detach a folder from an agent.
     */
    detach(folderID, params, options) {
        const { agent_id } = params;
        return this._client.patch(path `/v1/agents/${agent_id}/folders/detach/${folderID}`, options);
    }
}
//# sourceMappingURL=folders.mjs.map